import { alpha } from "@mui/material/styles"
import { dsColorNew } from "@palette"


// Values picked in a multiple dropdown show as soft chips (the chips of the dialogs), not filled dark ones
export const fieldGlobalStyles = {
	'.MuiChip-root.MuiAutocomplete-tag': {
		height: 24,
		borderRadius: '6px',
		backgroundColor: dsColorNew.pillActiveBg,
		color: dsColorNew.appBlue,
		fontSize: 13,
		fontWeight: 500,
		'& .MuiChip-deleteIcon': {
			fontSize: 16,
			color: alpha(dsColorNew.appBlue, 0.55),
			'&:hover': { color: dsColorNew.appBlue },
		},
	},
}
